import React, { useMemo } from 'react';
import { __t } from '../../../../../base/utils/t';
import { ClickTooltip } from '../../../../../base/components/ClickTooltip';
import { Icon } from '../../../../../base/components/Icon';
import { PhoneInput } from '../../../../../base/components/Forms/PhoneInput';
import { useAppDispatch, useAppSelector, useIsMobile } from '../../../../../base/hooks';
import { Select, SelectOption } from '../../../../../base/components/Forms/Select';
import { Messenger } from '../../../../../base/enums';
import { ReactComponent as TelegramIcon } from '../../../../../base/assets/img/telegram.svg';
import { ReactComponent as ViberIcon } from '../../../../../base/assets/img/viber.svg';
import { ReactComponent as WhatsAppIcon } from '../../../../../base/assets/img/whatsapp.svg';
import { ErrorMessage } from '../../../../../base/components/Forms/ErrorMessage';

import './styles.scss';
import { quickSignUpActions } from '../../../authorization/redux/slices/quickSignUpSlice';

export const ContactInfo = () => {
    const dispatch = useAppDispatch();
    const {
        fields: { phone, messenger },
        errors,
    } = useAppSelector((state) => state.workerAppQuickSignUp);
    const { phoneInputConfig } = useAppSelector((state) => state.workerApp.config);
    const isMobile = useIsMobile();

    const inputChangeHandler = (value: string) => {
        dispatch(quickSignUpActions.setField({ id: 'phone', value }));
    };

    const selectChangeHandler = (id: string, value: unknown) => {
        dispatch(quickSignUpActions.setField({ id, value }));
    };

    const selectOptions: SelectOption[] = useMemo(() => {
        return [
            {
                value: Messenger.Viber,
                text: __t('Использую Viber'),
                icon: <ViberIcon className='quick-apply-step-form__messenger-icon' width='24px' height='24px' />,
            },
            {
                value: Messenger.Telegram,
                text: __t('Использую Telegram'),
                icon: <TelegramIcon className='quick-apply-step-form__messenger-icon' width='24px' height='24px' />,
            },
            {
                value: Messenger.Whatsapp,
                text: __t('Использую Whatsapp'),
                icon: <WhatsAppIcon className='quick-apply-step-form__messenger-icon' width='24px' height='24px' />,
            },
            {
                value: Messenger.None,
                text: __t('Не использую мессенджеры'),
                icon: <Icon icon='comment-slash' className='quick-apply-step-form__messenger-icon' color='info' />,
            },
        ];
    }, []);

    return (
        <div className='quick-apply-step-form'>
            <div className='quick-apply-step-form__item'>
                <p className='quick-apply-step-form__label'>{__t('Номер телефона')}</p>
                {isMobile ? (
                    <PhoneInput
                        value={phone}
                        onChange={inputChangeHandler}
                        errors={errors?.phone}
                        onlyCountries={phoneInputConfig.countries}
                        preferredCountries={phoneInputConfig.preferredCountries}
                        localization={phoneInputConfig.localization}
                        tabIndex={1}
                        className='quick-apply-step-form__input quick-apply-step-form__input--collapse-bottom-border'
                        removeBorderRadius='bottom'
                        hideErrorMessage={true}
                    />
                ) : (
                    <ClickTooltip
                        activeButton={
                            <PhoneInput
                                value={phone}
                                onChange={inputChangeHandler}
                                errors={errors?.phone}
                                onlyCountries={phoneInputConfig.countries}
                                preferredCountries={phoneInputConfig.preferredCountries}
                                localization={phoneInputConfig.localization}
                                tabIndex={1}
                                className='quick-apply-step-form__input quick-apply-step-form__input--collapse-bottom-border'
                                removeBorderRadius='bottom'
                                hideErrorMessage={true}
                            />
                        }
                        align={isMobile ? 'left' : 'right'}
                        verticalAlign={isMobile ? 'top' : 'middle'}
                        className='quick-apply-step-form__input-tooltip'
                        wrapperClassName='quick-apply-step-form__input-tooltip-wrapper'
                        hideCloseIcon={true}
                    >
                        <div className='quick-apply-step-form__input-tooltip-content'>
                            <Icon
                                icon='circle-info-duonote'
                                color='warn'
                                className='quick-apply-step-form__input-tooltip-icon'
                            />
                            <p className='quick-apply-step-form__input-tooltip-title'>
                                {__t('Работодатели предпочитают связываться через мессенджеры. ')}
                            </p>
                        </div>
                    </ClickTooltip>
                )}

                <Select
                    id='messenger'
                    value={messenger as unknown as string}
                    options={selectOptions}
                    removeBorderRadius='top'
                    onChange={selectChangeHandler}
                    className='quick-apply-step-form__select'
                    dropdownClassname='quick-apply-step-form__dropdown'
                />
                <ErrorMessage errors={errors?.phone} />

                {isMobile && messenger === Messenger.None && (
                    <div className='quick-apply-step-form__alert-message'>
                        <Icon
                            icon='circle-info-duonote'
                            color='warn'
                            className='quick-apply-step-form__alert-message-icon'
                        />
                        <p className='quick-apply-step-form__alert-message-title'>
                            {__t('Работодатели предпочитают связываться через мессенджеры. ')}
                        </p>
                    </div>
                )}
            </div>
        </div>
    );
};
